<template>
  <div class="voucher-bg">
    <div class="voucher-header">
      <i class="back-btn" @click="$router.go(-1)"></i>
      <div class="voucher-title">交易已完成</div>
      <div class="voucher-subtitle">
        您已成功{{ paytypeText === '银行卡' ? '出售' : '购买' }} {{ usdt }} USDT
      </div>
    </div>
    <div class="voucher-card">
      <div class="user-row">
        <div class="user-avatar">
          <img src="../assets/images/bankIcon.png" v-if="paytype == 1" />
          <img src="../assets/images/alipayIcon.png" v-else-if="paytype == 2" />
        </div>
        <div class="user-info">
          <div class="user-name">{{ payName || '收款账户' }}</div>
          <div class="user-action">
            <span class="user-follow">关注</span>
            <span class="user-chat">聊天</span>
          </div>
        </div>
      </div>
      <div class="voucher-section">
        <div class="voucher-row">
          <span class="label">单价</span>
          <span class="value">¥{{ Number(price).toFixed(2) }}</span>
        </div>
        <div class="voucher-row">
          <span class="label">数量</span>
          <span class="value">{{ usdt }} USDT</span>
        </div>
        <div class="voucher-row">
          <span class="label">总金额</span>
          <span class="value highlight">¥{{ Number(Amount).toFixed(2) }}</span>
        </div>
        <div class="voucher-row">
          <span class="label">收款方式</span>
          <span class="value">
            <i class="paytype-icon" :class="paytype == 1 ? 'bank' : 'alipay'"></i>
            {{ paytypeText }}
          </span>
        </div>
        <div class="voucher-row">
          <span class="label">账户信息</span>
          <span class="value">{{ accountInfo }}</span>
        </div>
        <div class="voucher-row">
          <span class="label">对方姓名及昵称</span>
          <span class="value">{{ payName }}</span>
        </div>
        <div class="voucher-row">
          <span class="label">订单编号</span>
          <span class="value">{{ OrderNo }}</span>
        </div>
        <div class="voucher-row">
          <span class="label">下单时间</span>
          <span class="value">{{ OrderTime }}</span>
        </div>
      </div>
    </div>
    <div class="voucher-footer">
      <button class="voucher-btn">查看资产</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "voucher",
  data() {
    return {
      Amount: "",
      price: "",
      usdt: "",
      paytype: "",
      bankName: "",
      bankAccount: "",
      payName: "",
      OrderNo: "",
      OrderTime: ""
    };
  },
  computed: {
    paytypeText() {
      if (this.paytype == 1) return "银行卡";
      if (this.paytype == 2) return "支付宝";
      return this.paytype;
    },
    accountInfo() {
      if (this.paytype == 2) {
        // 支付宝
        if (!this.bankAccount) return "";
        // 判断是否为邮箱
        const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailReg.test(this.bankAccount)) {
          // 邮箱账号，@前后三位脱敏
          const [prefix, suffix] = this.bankAccount.split("@");
          if (prefix.length > 3) {
            const masked = prefix.slice(0, -3) + "***";
            return masked + "@" + suffix;
          } else {
            return "***@" + suffix;
          }
        } else {
          // 非邮箱账号，中间三位脱敏
          if (this.bankAccount.length > 6) {
            const start = this.bankAccount.slice(0, Math.floor((this.bankAccount.length - 3) / 2));
            const masked = "***";
            const end = this.bankAccount.slice(-Math.ceil((this.bankAccount.length - 3) / 2));
            return start + masked + end;
          } else if (this.bankAccount.length > 3) {
            // 长度不够6位，直接中间三位脱敏
            return this.bankAccount[0] + "***" + this.bankAccount.slice(-1);
          } else {
            // 长度很短，全部脱敏
            return "***";
          }
        }
      } else if (this.paytype == 1) {
        // 银行卡，前四位和后四位中间全部脱敏
        const bank = this.bankName || "";
        const acc = this.bankAccount || "";
        if (acc.length > 8) {
          const masked = acc.slice(0, 4) + "*".repeat(acc.length - 8) + acc.slice(-4);
          return bank ? `${bank}(${masked})` : `(${masked})`;
        } else if (acc.length > 4) {
          // 长度不够8位，前后各保留两位
          const masked = acc.slice(0, 2) + "*".repeat(acc.length - 4) + acc.slice(-2);
          return bank ? `${bank}(${masked})` : `(${masked})`;
        } else {
          // 长度很短，全部脱敏
          const masked = "*".repeat(acc.length);
          return bank ? `${bank}(${masked})` : `(${masked})`;
        }
      }
      return "";
    }
  },
  created() {
    var params = this.$store.state.routerStore.voucher.params;
    this.Amount = params.Amount || "";
    this.price = params.price || "";
    this.usdt = params.usdt || "";
    this.paytype = params.paytype || "";
    this.bankName = params.bankName || "";
    this.bankAccount = params.bankAccount || "";
    this.payName = params.payName || "";
    this.OrderNo = params.OrderNo || "";
    this.OrderTime = params.OrderTime || "";
  }
};
</script>

<style lang="less" scoped>
@bg: #181e36;
@card: #232b4a;
@main: #00a0de;
@text: #d9e3fd;
@sub: #96abe4;

.voucher-bg {
  min-height: 100vh;
  background: @bg;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.voucher-header {
  width: 100%;
  background: @card;
  padding: 16px 0 0 0;
  position: relative;

  .back-btn {
    position: absolute;
    left: 16px;
    top: 20px;
    width: 22px;
    height: 22px;
    background: url('../assets/images/back-icon.svg') no-repeat center center;
    background-size: contain;
    cursor: pointer;
  }

  .voucher-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: @text;
    margin-top: 8px;
  }

  .voucher-subtitle {
    text-align: center;
    font-size: 14px;
    color: @sub;
    margin: 8px 0 0 0;
    padding-bottom: 12px;
  }
}

.voucher-card {
  width: 92%;
  background: @card;
  border-radius: 12px;
  margin-top: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 18px 16px 10px 16px;
}

.user-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .user-avatar img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #2a3356;
  }

  .user-info {
    flex: 1;
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .user-name {
      font-size: 16px;
      color: @text;
      font-weight: 500;
    }

    .user-action {
      display: flex;
      gap: 8px;

      .user-follow,
      .user-chat {
        font-size: 13px;
        color: @main;
        background: #1a223d;
        border-radius: 12px;
        padding: 2px 10px;
        cursor: pointer;
      }
    }
  }
}

.voucher-section {
  border-top: 1px solid #2a3356;
  margin-top: 10px;
}

.voucher-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 0;
  font-size: 15px;
  border-bottom: 1px solid #2a3356;

  .label {
    color: @sub;
  }

  .value {
    color: @text;
    font-weight: 500;

    &.highlight {
      color: @main;
      font-size: 17px;
      font-weight: bold;
    }

    .paytype-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-right: 4px;

      &.bank {
        background: url('../assets/images/bankIcon.png') no-repeat center center;
        background-size: contain;
      }

      &.alipay {
        background: url('../assets/images/alipayIcon.png') no-repeat center center;
        background-size: contain;
      }
    }
  }
}

.voucher-footer {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: @card;
  padding: 12px 0 20px 0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: center;
}

.voucher-btn {
  width: 90%;
  height: 44px;
  background: @main;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  cursor: pointer;
}
</style>